<template>
  <div class="footer">
    <div class="mx-auto" style="max-width: 120px;">
      <img src="https://s3.amazonaws.com/assets.truemarketinsiders.com/contentful/logos/logo-footer.png" alt="True Market Insiders Logo">
    </div>
    <p class="text-center text-light small m-0">
      © {{ new Date().getFullYear() }} True Market Insiders. All Rights Reserved.
      <a href="https://truemarketinsiders.io/privacy-policy" target="_blank">Privacy Policy </a>&#8226;
      <a href="https://truemarketinsiders.io/refund-policy" target="_blank">Refund Policy </a>&#8226;
      <a href="https://truemarketinsiders.io/terms-of-use" target="_blank">Terms & Conditions </a>
    </p>
  </div>
</template>

<script>
export default {
  name: "Footer"
}
</script>
<style>
.footer {
  background: rgba(0, 0, 0, 0.8);
  width: 100%; height: 5rem;
  position: absolute; bottom: 0;
  font-size: 12px;
}
.footer img {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.footer a {
  color:#92acc7;
}
</style>
